import { render, staticRenderFns } from "./BidHistoryParticipantCard.vue?vue&type=template&id=03812a18&scoped=true"
import script from "./BidHistoryParticipantCard.vue?vue&type=script&lang=js"
export * from "./BidHistoryParticipantCard.vue?vue&type=script&lang=js"
import style0 from "./BidHistoryParticipantCard.vue?vue&type=style&index=0&id=03812a18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03812a18",
  null
  
)

export default component.exports